$(function(){

	// open tab on click
	$('.auth-tab').on('click', function(){
		var currentTabEl = $(this);
		var currentPanelEl = $('.auth-panel[data-panel="' + currentTabEl.attr('data-tab') + '"]');

		// if there is panel
		if(currentPanelEl.length) {
			// make active only current tab
			$('.auth-tab').removeClass('active');
			currentTabEl.addClass('active');

			// show only current panel
			$('.auth-panel').hide();
			currentPanelEl.show();
		}

	});

});